(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // ===== AUTO INFINITE SCROLL (desktop + mobile) =====
  (function () {
    if (window.__luxeInfiniteScrollInit) return;
    window.__luxeInfiniteScrollInit = true;

    var isLoading = false;

    function loadNext(container, results, nextUrl) {
      if (isLoading || !nextUrl) return;

      var sid = container.getAttribute('data-section-id');
      var u;
      try {
        u = new URL(nextUrl, window.location.origin);
        if (sid) u.searchParams.set('section_id', sid);
      } catch (err) {
        return;
      }

      isLoading = true;
      container.classList.add('is-loading');

      fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) {
          if (!r.ok) throw new Error('bad response');
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var items = doc.querySelectorAll('.product-grid__item');
          var first = results.querySelector('.product-grid__item');
          var list = first ? first.parentElement : null;

          if (!list || !items.length) throw new Error('no items');

          var frag = document.createDocumentFragment();
          Array.prototype.forEach.call(items, function (li) {
            if (li.id && document.getElementById(li.id)) return;
            var node = document.importNode(li, true);
            node.classList.add('product-grid__item--new');
            frag.appendChild(node);
          });
          list.appendChild(frag);

          var nextBox = doc.querySelector('.infinite-scroll-sentinel');
          var newNext = nextBox ? nextBox.getAttribute('data-next-url') || '' : '';
          container.setAttribute('data-next-url', newNext);

          if (!newNext) {
            container.classList.add('is-done');
          }

          isLoading = false;
          container.classList.remove('is-loading');
        })
        .catch(function () {
          isLoading = false;
          container.classList.remove('is-loading');
        });
    }

    function initObserver() {
      var sentinel = document.querySelector('.infinite-scroll-sentinel');
      if (!sentinel) return;

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var container = entry.target;
              var results = container.closest('results-list');
              var nextUrl = (container.getAttribute('data-next-url') || '').replace(/&amp;/g, '&');

              if (results) {
                results.classList.add('show-all-products');
              }

              if (nextUrl && !container.classList.contains('is-done')) {
                loadNext(container, results, nextUrl);
              } else {
                container.classList.add('is-done');
              }
            }
          });
        },
        { rootMargin: '200px' }
      );

      observer.observe(sentinel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initObserver);
    } else {
      initObserver();
    }
  })();

  // ===== WISHLIST HEART ON PRODUCT CARDS =====
  (function () {
    if (window.__luxeCardWishlistInit) return;
    window.__luxeCardWishlistInit = true;

    var WL_KEY = 'luxe_wishlist';

    function wlRead() {
      try {
        var raw = localStorage.getItem(WL_KEY);
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (err) {
        return [];
      }
    }

    function wlWrite(arr) {
      try {
        localStorage.setItem(WL_KEY, JSON.stringify(arr));
        return true;
      } catch (err) {
        return false;
      }
    }

    function wishlistUrl() {
      var link = document.querySelector('[data-luxe-wishlist-link]');
      return (link && link.getAttribute('href')) || '/pages/wishlist';
    }

    function showToast(msg, linkUrl, linkText) {
      var old = document.querySelector('.collection-toast');
      if (old && old.parentNode) old.parentNode.removeChild(old);

      var t = document.createElement('div');
      t.className = 'collection-toast';
      t.setAttribute('role', 'status');

      var span = document.createElement('span');
      span.textContent = msg;
      t.appendChild(span);

      if (linkUrl) {
        var a = document.createElement('a');
        a.href = linkUrl;
        a.textContent = linkText || 'View';
        t.appendChild(a);
      }

      document.body.appendChild(t);
      requestAnimationFrame(function () {
        t.classList.add('show');
      });
      setTimeout(function () {
        t.classList.remove('show');
        setTimeout(function () {
          if (t.parentNode) t.parentNode.removeChild(t);
        }, 300);
      }, 3000);
    }

    function syncAll() {
      var list = wlRead();
      var buttons = document.querySelectorAll('.card-wishlist-btn');
      Array.prototype.forEach.call(buttons, function (btn) {
        var on = list.indexOf(btn.getAttribute('data-wishlist-handle')) > -1;
        btn.classList.toggle('active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('.card-wishlist-btn') : null;
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var handle = btn.getAttribute('data-wishlist-handle');
        if (!handle) return;

        var list = wlRead();
        var i = list.indexOf(handle);
        var added;

        if (i > -1) {
          list.splice(i, 1);
          added = false;
        } else {
          list.push(handle);
          added = true;
        }

        if (!wlWrite(list)) {
          showToast('Wishlist save nahi ho paayi (browser storage blocked).');
          return;
        }

        syncAll();

        document.dispatchEvent(
          new CustomEvent('luxe:wishlist:updated', { detail: { count: list.length, handles: list } })
        );

        if (added) showToast('Added to wishlist', wishlistUrl(), 'View Wishlist');
        else showToast('Removed from wishlist');
      },
      true
    );

    var scheduled = false;
    function scheduleSync() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncAll();
      });
    }

    function start() {
      syncAll();
      new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    window.addEventListener('storage', function (e) {
      if (e.key === WL_KEY) syncAll();
    });
    document.addEventListener('luxe:wishlist:updated', syncAll);
  })();

  // ===== CARD IMAGE == PRODUCT PAGE IMAGE =====
  // Card par jo image dikh rahi hai, uska variant dhundh kar product link me ?variant=ID laga deta hai,
  // taaki product page usi variant (aur uski image) ke saath khule.
  (function () {
    if (window.__luxeCardVariantInit) return;
    window.__luxeCardVariantInit = true;

    function fileKey(src) {
      if (!src) return '';
      var s = src.split('?')[0].split('#')[0].split('/').pop();
      s = s.replace(/_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.[a-z0-9]+$)/i, '');
      try { s = decodeURIComponent(s); } catch (err) {}
      return s.toLowerCase();
    }

    function pickVariant(li) {
      var map = li.getAttribute('data-variant-images') || '';
      var img = li.querySelector('img');
      var key = img ? fileKey(img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '') : '';

      if (key && map) {
        var parts = map.split('|');
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          var cut = p.indexOf('~');
          if (cut < 1) continue;
          if (fileKey(p.slice(cut + 1)) === key) return p.slice(0, cut);
        }
      }
      return li.getAttribute('data-card-variant') || '';
    }

    function applyCard(li) {
      var id = pickVariant(li);
      if (!id) return;
      var links = li.querySelectorAll('a[href*="/products/"]');
      Array.prototype.forEach.call(links, function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.origin);
          var existing = u.searchParams.get('variant');
          if (existing === id) return;
          if (existing && a.getAttribute('data-luxe-variant') !== '1') return; // theme ne khud set kiya hai
          u.searchParams.set('variant', id);
          a.setAttribute('href', u.pathname + u.search + u.hash);
          a.setAttribute('data-luxe-variant', '1');
        } catch (err) {}
      });
    }

    function applyAll() {
      var cards = document.querySelectorAll('.product-grid__item[data-variant-images], .product-grid__item[data-card-variant]');
      Array.prototype.forEach.call(cards, applyCard);
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        applyAll();
      });
    }

    function start() {
      applyAll();
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      window.addEventListener('load', applyAll);
      [400, 1200, 2500].forEach(function (ms) { setTimeout(applyAll, ms); });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  })();

  } catch(e) { console.error(e); }
})();
})();
